const Slider = (function () {

    const $ = require('jquery');
    const self = {};

    self.init = function () {

        //  CE "help doorway" Slider
        self.helpDoorwaysSlider();

        //  CE media gallery
        self.mediaGallery();

        //  CE featured projects
        self.featuredProjects();

    };

    self.helpDoorwaysSlider = function () {

        let $helpDoorwaysSlider = $('.ce-help-doorways');

        if ($helpDoorwaysSlider.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            $helpDoorwaysSlider.each(function () {

                let $this = $(this);

                new Swiper($this.find('.swiper-container')[0], {
                    breakpoints: {
                        767: {
                            slidesPerGroup: 1,
                            slidesPerView: 1,
                            speed: 400
                        },
                        1024: {
                            slidesPerGroup: 2,
                            slidesPerView: 2
                        }
                    },
                    navigation: {
                        nextEl: $this.find('.swiper-button-next')[0],
                        prevEl: $this.find('.swiper-button-prev')[0]
                    },
                    spaceBetween: 40,
                    speed: 800,
                    slidesPerGroup: 3,
                    slidesPerView: 3,
                    watchOverflow: true,
                    on: {
                        init: function () {
                            setTimeout(function () {
                                App.Globals.$window.trigger('resize');
                            }, 700);

                        },
                    }
                });
                
            });

        }

    };

    self.featuredProjects = function () {

        let $featuredProjects = $('.ce-featured-projects');

        if ($featuredProjects.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            $featuredProjects.each(function () {

                let $this = $(this);

                new Swiper($this.find('.swiper-container')[0], {
                    navigation: {
                        nextEl: $this.find('.swiper-button-next')[0],
                        prevEl: $this.find('.swiper-button-prev')[0]
                    },
                    spaceBetween: 100,
                    speed: 800,
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    watchOverflow: true
                });
                
            });

        }

    };

    self.mediaGallery = function () {
        
        let $mediaGallery = $('.ce-media-gallery');

        if ($mediaGallery.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            $mediaGallery.each(function () {
                
                let $this = $(this);

                new Swiper($this.find('.swiper-container')[0], {
                    navigation: {
                        nextEl: $this.find('.swiper-button-next')[0],
                        prevEl: $this.find('.swiper-button-prev')[0]
                    },
                    spaceBetween: 40,
                    speed: 800,
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    watchOverflow: true
                });
                
            });

        }

    };

    return self;

}());

module.exports = Slider;
